import { MTableHeader } from 'material-table';
import React from 'react';
import PropTypes from 'prop-types';

const Header = (props, tableRef) => {
  if (!tableRef) {
    return <MTableHeader {...props} />;
  }
  const { state, dataManager } = tableRef;
  const { data } = dataManager;
  const { options } = props;

  const pageRows = state?.renderData || [];

  const isRowDisabled = row => Boolean(options?.selectionProps?.(row)?.disabled);

  const selectablePageRows = pageRows.filter(row => !isRowDisabled(row));
  const pageSelectedCount = selectablePageRows.filter(r => r.tableData?.checked).length;

  const handlePageAllSelected = (checked) => {
    pageRows.forEach((_, index) => {
      const { tableData } = pageRows[index];
      tableData.checked = isRowDisabled(pageRows[index]) ? false : checked;
    });

    dataManager.selectedCount = data?.filter(
      dataRow => dataRow.tableData?.checked,
    ).length;

    // eslint-disable-next-line react/destructuring-assignment
    tableRef.setState({ ...dataManager.getRenderState() });
  };

  return (
    <MTableHeader
      {...props}
      dataCount={selectablePageRows?.length}
      selectedCount={pageSelectedCount}
      onAllSelected={handlePageAllSelected}
    />
  );
};

Header.propTypes = {
  tableRef: PropTypes.object.isRequired,
};

export default Header;
